export enum Department {
    Accounting = "Accounting",
    Admin = "Admin",
    Advertising = "Advertising",
    Defence = "Defence",
    Agriculture = "Agriculture",
    Aviation = "Aviation",
    Entertainment = "Entertainment",
    Banking = "Banking",
    Construction = "Construction",
    BusinessManagement = "BusinessManagement",
    CallCentre = "CallCentre",
    Petrochemical = "Petrochemical",
    SocialServices = "SocialServices",
    DesignServices = "DesignServices",
    Warehousing = "Warehousing",
    Education = "Education",
    Engineering = "Engineering",
    FMCG = "FMCG",
    GovernmentAndParastatals = "GovernmentAndParastatals",
    Sports = "Sports",
    Hospitality = "Hospitality",
    HumanResources = "HumanResources",
    IT = "IT",
    Insurance = "Insurance",
    Investment = "Investment",
    Legal = "Legal",
    Logistics = "Logistics",
    Manufacturing = "Manufacturing",
    Marketing = "Marketing",
    Medical = "Medical",
    Mining = "Mining",
    General = "General",
    Media = "Media",
    RealEstate = "RealEstate",
    Retail = "Retail",
    Security = "Security",
    Sales = "Sales",
    Technology = "Technology",
    Telecommunications = "Telecommunications",
    Clothing = "Clothing",
    TradesAndServices = "TradesAndServices",
    TravelAndTourism = "TravelAndTourism",
    Finance = "Finance",
    Automotive = "Automotive",
    Academic = "Academic",
    Chemical = "Chemical",
    Fashion = "Fashion",
    ImportAndExport = "ImportAndExport",
    HealthFitnessAndBeauty = "HealthFitnessAndBeauty",
    Management = "Management",
    Consulting = "Consulting",
    Motoring = "Motoring",
    NGOAndNonProfit = "NGOAndNonProfit",
    PRAndCommunication = "PRAndCommunication",
    Procurement = "Procurement",
    Property = "Property",
    Purchasing = "Purchasing",
    Research = "Research",
    Stockbroking = "Stockbroking",
    Technical = "Technical",
    Internet = "Internet",
    Environmental = "Environmental",
    CruiseShip = "CruiseShip",
    Pharmaceutical = "Pharmaceutical",
    Graduate = "Graduate",
    MarketResearch = "MarketResearch",
    HealthAndSafety = "HealthAndSafety",
    Recruitment = "Recruitment",
    ECommerce = "ECommerce",
    Lifestyle = "Lifestyle",
    SoftSkills = "SoftSkills",
    Freight = "Freight"
}